import { AbstractControl, ValidatorFn } from "@angular/forms";
import { PhoneNumberUtil } from 'google-libphonenumber';
const phoneNumberUtil = PhoneNumberUtil.getInstance();

export function isRSAIdentity(identityTypeControlName = 'identityType'): ValidatorFn {
	return (control: AbstractControl) => {

		if (!control?.value || control.parent === null) return null;

		const identityType = control.parent.get(identityTypeControlName) as AbstractControl;
		// const identityType = control.parent.get('identityType') as AbstractControl;

		const type = parseInt(identityType.value);

		if (type != 1) {
			return null;
		}


		if (isNaN(control.value)) {
			return {
				'NotANumber': true
			};
		}

		if (control.value % 1 !== 0) {
			return {
				'NotAWholeNumber': true
			};
		}

		if (parseInt(control.value) < 0) {
			return {
				'NotAPossitiveNumber': true
			};
		}

		if (!IDNumberValidator.validateMonth(control.value)) {
			return {
				'InvalidMonth': true
			};
		}

		if (!IDNumberValidator.validateDay(control.value)) {
			return {
				'InvalidDay': true
			};
		}

		if (!IDNumberValidator.validateCitizen(control.value)) {
			return {
				'InvalidCitizen': true
			};
		}

		if (!IDNumberValidator.validateControlDigit(control.value)) {
			return {
				'InvalidControlDigit': true
			};
		}

		if (control.value.length !== 13) {
			return {
				'InvalidLength': true
			};
		}

		return null;
	};
}

export class IDNumberValidator {

	static validateCitizen(value: string): boolean {
		if (value.length < 11) {
			return true;
		}

		const citizen = parseInt(value.substr(10, 1));

		if (citizen > 1) {
			return false;
		}

		return true;
	}

	static validateDay(value: string): boolean {
		if (value.length < 6) {
			return true;
		}

		const day = parseInt(value.substr(4, 2));

		// this takes care of 1,3,5,7,8,10,12 months
		if (day <= 0 || day > 31) {
			return false;
		}

		const month = parseInt(value.substr(2, 2));

		if (month == 4 || month == 6 || month == 9 || month == 11) {
			if (day > 30) {
				return false;
			}
		}

		if (month == 2) {
			const year = parseInt(value.substr(0, 2));

			// let fiveYear = (new Date()).getFullYear() - 2005;
			//2018 - 2005 = 13 -- catering for 5 year olds up

			//cater for both 20xx and 19xx

			const date2000 = new Date(2000 + year, month - 1, day);
			const date1900 = new Date(1900 + year, month - 1, day)
			if (date2000.getMonth() !== 1 && date1900.getMonth() !== 1) {
				return false;
			}
		}

		return true;
	}

	static validateMonth(string: string): boolean {
		if (string.length < 4) {
			return true;
		}

		const month = parseInt(string.substr(2, 2));

		if (month <= 0 || month > 12) {
			return false;
		}

		return true;
	}

	static validateControlDigit(string: string): boolean {
		if (string.length !== 13) {
			return true;
		}

		let response = false;
		const controlDigit = string.substring(12);
		let oddSum = 0;
		let evenSum = 0;
		let evenCollection = '';

		for (let i = 0; i < 12; i++) {
			if (i % 2 === 0) {
				// odd
				oddSum += parseInt(string.substr(i, 1), 10);
			} else {
				// even
				evenCollection += parseInt(string.substr(i, 1), 10);
			}
		}

		evenCollection = (parseInt(evenCollection, 10) * 2).toString();

		for (let i = 0; i < evenCollection.length; i++) {
			evenSum += parseInt(evenCollection.substr(i, 1), 10);
		}

		let calculateDigit = oddSum + evenSum;

		calculateDigit = 10 - parseInt(calculateDigit.toString().substr(calculateDigit.toString().length - 1), 10);

		if (calculateDigit === 10) {
			calculateDigit = 0;
		}

		response = calculateDigit === parseInt(controlDigit, 10);

		return response;
	}

}

export function PhoneNumberValidator(regionCode?: string): ValidatorFn {
	return (control: AbstractControl) => {
		let validNumber = false;
		try {
			const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(control.value, regionCode);
			validNumber = phoneNumberUtil.isValidNumber(phoneNumber);
		} catch (e) {
			// Do nothing...
		}

		return validNumber ? null : { 'invalidNumber': { value: control.value } };
	}
}

export function bankDetailsSyncValidator(form: AbstractControl) {
	const controls = [
		form.get('bank'),
		form.get('branchCode'),
		form.get('bankAccountType'),
		form.get('bankAccountNumber')
	];

	// If the "pleaseCheck" error is present and one of the fields is changed, remove the error from all fields.
	const childContainsPleaseCheckError = controls.some(c => c?.errors?.['pleaseCheck'])

	if (childContainsPleaseCheckError && (!form.errors || form.errors['invalidBankDetails'] === true) && form.valid)
		setTimeout(() => controls.forEach(c => c?.updateValueAndValidity({ emitEvent: false }))); // SetTimeout to prevent infinite loop.
}

export function accountHolderIdNotSameAsCustomerIdValidator(): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
        const customerIdControl = formGroup.parent?.get('customerInformation.identityNumber');
        const accountHolderIdControl = formGroup.get('accountHolderIdentityNumber');

        if (!customerIdControl || !accountHolderIdControl || !accountHolderIdControl.value) {
            // If controls are not found or accountHolderId is empty, don't validate
            return null;
        }

        const customerId = customerIdControl.value;
        const accountHolderId = accountHolderIdControl.value;

        if (customerId && accountHolderId && customerId === accountHolderId) {
            // Set the error on the accountHolderIdentityNumber control itself
            accountHolderIdControl.setErrors({ ...accountHolderIdControl.errors, 'sameAsCustomerId': true });
            return { 'sameAsCustomerId': true }; // Also return error for the group if needed for group-level display
        } else {
            // If the error was previously set and now it's valid, remove it
            if (accountHolderIdControl.errors?.['sameAsCustomerId']) {
                const { sameAsCustomerId, ...rest } = accountHolderIdControl.errors;
                accountHolderIdControl.setErrors(Object.keys(rest).length > 0 ? rest : null);
            }
        }

        return null;
    };
}